import { Resource as r, API as i } from "@coveo/platform-client";
const a = class a extends r {
  /**
   * Fetch listing engagements per facet metrics by organization
   * @param options
   * @returns FacetPerformanceMetricsPageModel
   */
  fetchListingEngagementsPerFacet(e, t) {
    return this.api.get(
      this.buildPath(`${a.baseUrl}/listing-engagements-per-facet`, {
        ...t,
        trackingId: e
      })
    );
  }
  /**
   * Fetch search engagements per facet metrics by organization
   * @param options
   * @returns FacetPerformanceMetricsPageModel
   */
  fetchSearchEngagementsPerFacet(e, t) {
    return this.api.get(
      this.buildPath(`${a.baseUrl}/search-engagements-per-facet`, {
        ...t,
        trackingId: e
      })
    );
  }
  /**
   * Fetch listing engagements per facet value metrics by organization
   * @param options
   * @returns FacetValuePerformanceMetricsPageModel
   */
  fetchListingEngagementsPerFacetValue(e, t) {
    return this.api.get(
      this.buildPath(`${a.baseUrl}/listing-engagements-per-facet-value`, {
        ...t,
        trackingId: e
      })
    );
  }
  /**
   * Fetch search engagements per facet value metrics by organization
   * @param options
   * @returns FacetValuePerformanceMetricsPageModel
   */
  fetchSearchEngagementsPerFacetValue(e, t) {
    return this.api.get(
      this.buildPath(`${a.baseUrl}/search-engagements-per-facet-value`, {
        ...t,
        trackingId: e
      })
    );
  }
  /**
   * Fetch facet engagements per listing page metrics by organization
   * @param options
   * @returns FacetEngagementsMetricsPageModel
   */
  fetchFacetEngagementsPerListing(e, t) {
    return this.api.get(
      this.buildPath(`${a.baseUrl}/facet-engagements-per-listing`, {
        ...t,
        trackingId: e
      })
    );
  }
  /**
   * Fetch facet engagements per search query metrics by organization
   * @param options
   * @returns FacetEngagementsMetricsPageModel
   */
  fetchFacetEngagementsPerSearch(e, t) {
    return this.api.get(
      this.buildPath(`${a.baseUrl}/facet-engagements-per-search`, {
        ...t,
        trackingId: e
      })
    );
  }
};
a.baseUrl = `/rest/organizations/${i.orgPlaceholder}/commerce/reports/private/facet-performance`;
let s = a;
export {
  s as FacetPerformanceReportingMetrics
};
//# sourceMappingURL=FacetPerformanceReportingMetrics.js.map
